import { render, staticRenderFns } from "./DialogCancelamentoSolicitacao.vue?vue&type=template&id=3dc4ce87"
import script from "./DialogCancelamentoSolicitacao.vue?vue&type=script&lang=js"
export * from "./DialogCancelamentoSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports